export default __webpack_public_path__ + "static/media/arrow-up-circle.27fb40fe.svg";